import React, { useEffect } from 'react';
import { Button, Form, Input, message, Row, Modal } from 'antd';
import { amesSendMail } from 'helpers/MailHelper';
import { useState } from 'react';
import { updatePassword } from 'services/AuthService';

type Props = {
  userInfor: {
    email: string;
    fullName: string;
  };
  onSuccess?: Function;
};

const ChangePasswordPopup = ({ userInfor, onSuccess }: Props) => {
  const [form] = Form.useForm();
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = (values: any) => {
    setIsProcessing(true);
    const { email, fullName } = userInfor;
    const { password } = values;

    updatePassword({
      email: email,
      password: password,
    })
      .then(async () => {
        const dataSendMail = {
          to: email,
          isSendFast: true,
          subject: `THÔNG BÁO THAY ĐỔI MẬT KHẨU`,
          templateMail: 'SACHSO_Mail_ResetPassword',
          templateData: {
            email: email,
            password: password,
            studentName: fullName,
          },
        };
        const resMail = await amesSendMail(dataSendMail);
        if (resMail?.Message !== 'OK') {
          message.error('Có lỗi xảy ra trong quá trình gửi mail',10);
          setIsProcessing(false);
          return;
        }
        setIsVisibleModal(false);
        message.success(`Mật khẩu mới đã được gửi về mail ${email}`,10);
        form.resetFields();
        onSuccess?.();
        setIsProcessing(false);
      })
      .catch((err) => {
        message.error('Có lỗi xảy ra khi lưu dữ liệu',10);
        setIsProcessing(false);
      });
  };

  //Lắng nghe có email vào thì bật modal lên
  useEffect(() => {
    if (userInfor?.email) {
      setIsVisibleModal(true);
    }
  }, [userInfor]);

  return (
    <div>
      <Modal title='ĐỔI MẬT KHẨU' visible={isVisibleModal} onCancel={() => setIsVisibleModal(false)} footer={null}>
        <Form form={form} onFinish={handleSubmit} layout='vertical'>
          <Form.Item
            label='Mật khẩu mới'
            hasFeedback
            name='password'
            rules={[
              { min: 6, message: 'Tối thiểu 6 ký tự!' },
              {
                whitespace: true,
                message: 'Vui lòng nhập mật khẩu!',
              },
              {
                required: true,
                message: 'Vui lòng nhập mật khẩu!',
              },
            ]}
          >
            <Input.Password
              style={{
                borderRadius: 5,
              }}
              allowClear
              size='large'
            />
          </Form.Item>
          <Form.Item
            label='Xác nhận khẩu mới'
            dependencies={['password']}
            hasFeedback
            name='rePassword'
            rules={[
              {
                whitespace: true,
                message: 'Vui lòng xác nhận lại nhập mật khẩu!',
              },
              {
                required: true,
                message: 'Vui lòng xác nhận lại nhập mật khẩu!',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Mật khẩu không trùng khớp!');
                },
              }),
            ]}
          >
            <Input.Password
              style={{
                borderRadius: 3,
              }}
              allowClear
              size='large'
            />
          </Form.Item>

          <Row justify='end'>
            <Button onClick={() => form.submit()} type='primary' loading={isProcessing} icon={<i className='fas fa-edit' />}>
              Cập nhật
            </Button>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default ChangePasswordPopup;
